import NotificationsPage from './views/notification.page';

NotificationsPage.path = '/notifications';

export default {
  views: {
    NotificationsPage
  }
};
